// We want to funnel all ChakraProvider instances through this component
// so that we can control the Provider props from a single location.

import { ChakraProvider, ChakraProviderProps } from '@chakra-ui/react';

/* eslint-disable react/forbid-elements */
export default function ChakraDefaultProvider(props: ChakraProviderProps) {
   return <ChakraProvider {...props} resetCSS={false} />;
}
